import React, { useState } from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { IoFilterOutline } from "react-icons/io5";
import { FaXmark } from "react-icons/fa6";

function Filter() {
  const [isOpen, setIsOpen] = useState(false);
  const [filters, setFilters] = useState([
    { field: "", condition: "", value: "" },
  ]);

  const fields = ["Admin", "SubAdmin", "ID"];
  const conditions = ["Equal", "Not Equal", "Contains"];

  const toggleFilter = () => setIsOpen((prev) => !prev);

  const handleAddFilter = () => {
    setFilters([...filters, { field: "", condition: "", value: "" }]);
  };

  const handleChange = (index, type, value) => {
    const newFilters = [...filters];
    newFilters[index][type] = value;
    setFilters(newFilters);
  };

  const handleDelete = (index) => {
    setFilters((prev) => prev.filter((_, i) => i !== index));
  };

  const handleClear = () => {
    setFilters([{ field: "", condition: "", value: "" }]);
    setIsOpen(false);
  };

  const handleApply = () => {
    console.log("Applied Filters:", filters);
    setIsOpen(false);
  };

  return (
    <div className="relative inline-block text-left">
      {/* Filter Button */}
      <div className="group relative cursor-pointer">
        <div
          data-tooltip-id="main-tooltip"
          data-tooltip-content="Filter"
          onClick={toggleFilter}
          className="text-sm bg-gray-200 text-gray-500 shadow-sm
            font-semibold rounded-md px-4 py-1.5 flex gap-2
            items-center justify-center text-center border
            border-transparent
            hover:text-gray-800 transition-all"
        >
          <IoFilterOutline size={18} />
          Filter
        </div>
      </div>

      {/* Filter Dropdown */}
      {isOpen && (
        <div
          className="absolute right-0 z-50 mt-2 w-[380px] bg-white shadow-lg border rounded-md text-sm p-4"
          onMouseLeave={() => setIsOpen(false)}
        >
          {/* Dynamic Filters */}
          {filters.map((filter, index) => (
            <div
              key={index}
              className="flex items-center justify-between gap-2 mb-2"
            >
              {/* Field Select */}
              <select
                className="border px-2 py-1 outline-none rounded w-1/3"
                value={filter.field}
                onChange={(e) => handleChange(index, "field", e.target.value)}
              >
                <option value="">Select</option>
                {fields.map((field, idx) => (
                  <option key={idx} value={field}>
                    {field}
                  </option>
                ))}
              </select>

              {/* Condition Select */}
              <select
                className="border px-2 py-1 outline-none rounded w-1/3"
                value={filter.condition}
                onChange={(e) =>
                  handleChange(index, "condition", e.target.value)
                }
              >
                <option value="">Select</option>
                {conditions.map((cond, idx) => (
                  <option key={idx} value={cond}>
                    {cond}
                  </option>
                ))}
              </select>

              {/* Value Select */}
              <select
                className="border px-2 py-1 outline-none rounded w-1/3"
                value={filter.value}
                onChange={(e) => handleChange(index, "value", e.target.value)}
              >
                <option value="">Select</option>
                {fields.map((val, idx) => (
                  <option key={idx} value={val}>
                    {val}
                  </option>
                ))}
              </select>

              {/* Delete Button */}
              <button
                onClick={() => handleDelete(index)}
                className="text-black cursor-pointer"
              >
                <FaXmark size={20} />
              </button>
            </div>
          ))}

          {/* Add Filter Link */}
          <div
            onClick={handleAddFilter}
            className="text-blue-500 text-sm cursor-pointer hover:underline mb-3"
          >
            + Add Filter
          </div>

          {/* Action Buttons */}
          <div className="flex justify-end gap-2">
            <button
              className="border border-gray-300 px-3 py-1 rounded text-sm hover:bg-gray-100"
              onClick={handleClear}
            >
              Clear
            </button>
            <button
              disabled={filters.some(
                (f) => !f.field || !f.condition || !f.value
              )}
              className="bg-blue-500 text-white px-4 py-1 rounded text-sm hover:bg-blue-600 disabled:bg-blue-300"
              onClick={handleApply}
            >
              Apply Filter
            </button>
          </div>
        </div>
      )}

      {/* Tooltip */}
      <ReactTooltip
        id="main-tooltip"
        place="top"
        effect="solid"
        className="!text-[14px] !rounded-md !px-5 !py-[2px] !text-white z-20 shadow-md"
      />
    </div>
  );
}

export default Filter;